/*configuring-development-tasks*/
/*running-setup-tasks-before-dev*/
/*running-a-specific-application*/
/*using-the-terminal-ui*/
/*customizing-your-view*/
/*interacting-with-tasks*/
/*watch-mode*/
/*limitations*/
/*teardown-tasks*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "开发应用",
  "description": "了解如何在存储库中开发应用。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "在单一代码库中开发应用可以解锁强大的工作流程，使你能够通过轻松访问代码对源代码控制进行原子提交。"
  }, {
    "heading": "",
    "content": "¥Developing applications in a monorepo unlocks powerful workflows, enabling you to make atomic commits to source control with easy access to code."
  }, {
    "heading": "",
    "content": "大多数开发任务都是长期运行的任务，会监视代码的更改。Turborepo 通过强大的终端 UI 和其他功能增强了此体验，例如："
  }, {
    "heading": "",
    "content": "¥Most development tasks are long-running tasks that watch for changes to your code. Turborepo enhances this experience with a powerful terminal UI and other capabilities like:"
  }, {
    "heading": "",
    "content": "dev 任务配置"
  }, {
    "heading": "",
    "content": "¥Configuration for dev tasks"
  }, {
    "heading": "",
    "content": "与任务交互"
  }, {
    "heading": "",
    "content": "¥Interacting with tasks"
  }, {
    "heading": "",
    "content": "监视模式"
  }, {
    "heading": "",
    "content": "¥Watch Mode"
  }, {
    "heading": "",
    "content": "正在运行安装脚本"
  }, {
    "heading": "",
    "content": "¥Running setup scripts"
  }, {
    "heading": "",
    "content": "过滤任务以运行包的子集"
  }, {
    "heading": "",
    "content": "¥Filtering tasks to run a subset of your packages"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥Configuring development tasks"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "在 turbo.json 中定义开发任务会告知 Turborepo 你将运行一个长期任务。这对于运行开发服务器、运行测试或构建应用等操作非常有用。"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥Defining a development task in turbo.json tells Turborepo that you'll be running a long-lived task. This is useful for things like running a development server, running tests, or building your application."
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "要注册 dev 任务，请将其添加到你的 turbo.json 中，并添加以下两个属性："
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥To register a dev task, add it to your turbo.json with two properties:"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "\"cache\"：false：指示 Turborepo 不要尝试缓存任务的结果。由于这是一项开发任务，你可能会频繁更改代码，因此缓存结果毫无意义。"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥\"cache\": false: Tells Turborepo to not attempt to cache the results of the task. Since this is a development task, you're likely to be making frequent changes to your code, so caching the results is not useful."
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "\"persistent\"：true:指示 Turborepo 保持任务运行，直到你停止它。此键会向你的终端 UI 触发信号，指示该任务被视为长时间运行且可交互。此外，它还可以防止你意外依赖不会退出的任务。"
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥\"persistent\": true: Tells Turborepo to keep the task running until you stop it. This key serves as a signal for your terminal UI to treat the task as long-running and interactive. Additionally, it prevents you from accidentally depending on a task that will not exit."
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "你现在可以运行 dev 任务来并行启动开发脚本："
  }, {
    "heading": "配置开发任务-configuring-development-tasks",
    "content": "¥You can now run your dev task to start your development scripts in parallel:"
  }, {
    "heading": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "¥Running setup tasks before dev"
  }, {
    "heading": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "你可能还想运行设置开发环境或预构建包的脚本。你可以使用 dependsOn 确保这些任务在 dev 任务之前运行："
  }, {
    "heading": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "¥You may also want to run scripts that set up your development environment or pre-build packages. You can make sure those tasks run before the dev task with dependsOn:"
  }, {
    "heading": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "在本例中，我们使用的是 根任务，但你可以对 包中的任意任务 使用相同的方法。"
  }, {
    "heading": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "¥In this example, we're using a Root Task but you can use the same idea for arbitrary tasks in packages."
  }, {
    "heading": "运行特定应用-running-a-specific-application",
    "content": "¥Running a specific application"
  }, {
    "heading": "运行特定应用-running-a-specific-application",
    "content": "--filter 标志允许你选择 软件包图表 的子集，以便你可以为特定应用及其依赖运行 dev 任务："
  }, {
    "heading": "运行特定应用-running-a-specific-application",
    "content": "¥The --filter flag allows you to pick a subset of your Package Graph so you can run your dev task for a specific application and its dependencies:"
  }, {
    "heading": "使用终端-ui-using-the-terminal-ui",
    "content": "¥Using the terminal UI"
  }, {
    "heading": "使用终端-ui-using-the-terminal-ui",
    "content": "Turborepo 的终端 UI 支持多种功能，可为你的任务创建高度交互的体验。"
  }, {
    "heading": "使用终端-ui-using-the-terminal-ui",
    "content": "¥Turborepo's terminal UI enables a number of features that create a highly interactive experience around your tasks."
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "¥Customizing your view"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "你可以使用快捷键快速调整 UI 以满足你的需求。"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "¥You can quickly adjust the UI to your needs using keybinds."
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "按键绑定"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "操作"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "m"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "切换弹出式按键绑定列表"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "↑/↓"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "在任务列表中选择下一个/上一个任务"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "j/k"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "在任务列表中选择下一个/上一个任务"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "p"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "切换选定任务的固定选择"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "h"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "切换任务列表的可见性"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "c"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "日志高亮显示时，将选定内容复制到系统剪贴板"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "u/d"
  }, {
    "heading": "自定义视图-customizing-your-view",
    "content": "滚动日志 up 和 down"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "¥Interacting with tasks"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "某些工具可能允许你在其中键入输入。例如 Drizzle ORM 的交互式迁移或 Jest 的测试套件过滤和重新运行。"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "¥Some of your tools may allow you to type input into them. Examples of this include Drizzle ORM's interactive migrations or Jest's filtering and re-running of test suites."
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "你可以与 标记为交互式 任务交互，为其提供输入。"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "¥You can interact with tasks that are marked as interactive to give them input."
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "按键绑定"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "操作"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "i"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "开始交互"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "Ctrl+z"
  }, {
    "heading": "与任务交互-interacting-with-tasks",
    "content": "停止交互"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥Watch Mode"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "许多工具都内置了监视器，例如 tsc --watch，它可以响应源代码中的更改。但是，有些任务日志不隐藏。"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥Many tools have a built-in watcher, like tsc --watch,\nthat will respond to changes in your source code. However, some don't."
  }, {
    "heading": "监视模式-watch-mode",
    "content": "turbo watch 为任何工具添加了一个依赖感知监视器。源代码的更改将遵循你在 turbo.json 中描述的 任务图，就像你的所有其他任务一样。"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥turbo watch adds a dependency-aware watcher to any tool. Changes to source code will follow the Task Graph that you've described in turbo.json, just like all your other tasks."
  }, {
    "heading": "监视模式-watch-mode",
    "content": "例如，使用类似 create-turbo 的包结构，其中包含以下任务和脚本："
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥For example, using a package structure like create-turbo with the following tasks and scripts:"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "运行 turbo watch dev lint 时，尽管 ESLint 没有内置的监视程序，但每当你更改源代码时，你都会看到 lint 脚本重新运行。turbo watch 还能感知内部依赖，因此 @repo/ui 中的代码更改将在 @repo/ui 和 web 中重新运行该任务。"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥When you run turbo watch dev lint, you'll see the lint scripts are re-run whenever you make source code changes, despite ESLint not having a built-in watcher. turbo watch is also aware of internal dependencies, so a code change in @repo/ui will re-run the task in both @repo/ui and web."
  }, {
    "heading": "监视模式-watch-mode",
    "content": "web 中的 Next.js 开发服务器和 @repo/ui 中 TypeScript 编译器的内置监视器将继续正常工作，因为它们被标记为 persistent。"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥The Next.js development server in web and the TypeScript Compiler's built-in watcher in @repo/ui will continue to work as usual, since they are marked with persistent."
  }, {
    "heading": "监视模式-watch-mode",
    "content": "更多信息，请使用 访问 turbo watch 参考。"
  }, {
    "heading": "监视模式-watch-mode",
    "content": "¥For more information, visit the turbo watch reference."
  }, {
    "heading": "限制-limitations",
    "content": "¥Limitations"
  }, {
    "heading": "拆卸任务-teardown-tasks",
    "content": "¥Teardown tasks"
  }, {
    "heading": "拆卸任务-teardown-tasks",
    "content": "在某些情况下，你可能希望在 dev 任务停止时运行脚本。Turborepo 在退出时无法运行那些拆卸脚本，因为 turbo 会在你的 dev 任务退出时退出。"
  }, {
    "heading": "拆卸任务-teardown-tasks",
    "content": "¥In some cases, you may want to run a script when the dev task is stopped. Turborepo is unable to run those teardown scripts when exiting because turbo exits when your dev tasks exit."
  }, {
    "heading": "拆卸任务-teardown-tasks",
    "content": "相反，创建一个 turbo dev:teardown 脚本，在退出主要 turbo dev 任务后单独运行该脚本。"
  }, {
    "heading": "拆卸任务-teardown-tasks",
    "content": "¥Instead, create a turbo dev:teardown script that you run separately after you've exited your primary turbo dev task."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "当你有了想要部署的应用版本后，就该学习如何在 Turborepo 中配置环境变量了。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Once you have a version of your application that you'd like to deploy, it's time to learn how to configure environment variables in Turborepo."
  }],
  "headings": [{
    "id": "配置开发任务-configuring-development-tasks",
    "content": "配置开发任务 /*configuring-development-tasks*/"
  }, {
    "id": "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
    "content": "在 dev 之前运行设置任务 /*running-setup-tasks-before-dev*/"
  }, {
    "id": "运行特定应用-running-a-specific-application",
    "content": "运行特定应用 /*running-a-specific-application*/"
  }, {
    "id": "使用终端-ui-using-the-terminal-ui",
    "content": "使用终端 UI /*using-the-terminal-ui*/"
  }, {
    "id": "自定义视图-customizing-your-view",
    "content": "自定义视图 /*customizing-your-view*/"
  }, {
    "id": "与任务交互-interacting-with-tasks",
    "content": "与任务交互 /*interacting-with-tasks*/"
  }, {
    "id": "监视模式-watch-mode",
    "content": "监视模式 /*watch-mode*/"
  }, {
    "id": "限制-limitations",
    "content": "限制 /*limitations*/"
  }, {
    "id": "拆卸任务-teardown-tasks",
    "content": "拆卸任务 /*teardown-tasks*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#配置开发任务-configuring-development-tasks",
  title: _jsx(_Fragment, {
    children: "配置开发任务 "
  })
}, {
  depth: 3,
  url: "#在-dev-之前运行设置任务-running-setup-tasks-before-dev",
  title: _jsxs(_Fragment, {
    children: ["在 ", _jsx("code", {
      children: "dev"
    }), " 之前运行设置任务 "]
  })
}, {
  depth: 3,
  url: "#运行特定应用-running-a-specific-application",
  title: _jsx(_Fragment, {
    children: "运行特定应用 "
  })
}, {
  depth: 2,
  url: "#使用终端-ui-using-the-terminal-ui",
  title: _jsx(_Fragment, {
    children: "使用终端 UI "
  })
}, {
  depth: 3,
  url: "#自定义视图-customizing-your-view",
  title: _jsx(_Fragment, {
    children: "自定义视图 "
  })
}, {
  depth: 3,
  url: "#与任务交互-interacting-with-tasks",
  title: _jsx(_Fragment, {
    children: "与任务交互 "
  })
}, {
  depth: 2,
  url: "#监视模式-watch-mode",
  title: _jsx(_Fragment, {
    children: "监视模式 "
  })
}, {
  depth: 2,
  url: "#限制-limitations",
  title: _jsx(_Fragment, {
    children: "限制 "
  })
}, {
  depth: 3,
  url: "#拆卸任务-teardown-tasks",
  title: _jsx(_Fragment, {
    children: "拆卸任务 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "在单一代码库中开发应用可以解锁强大的工作流程，使你能够通过轻松访问代码对源代码控制进行原子提交。"
    }), "\n", _jsx(_components.p, {
      children: "¥Developing applications in a monorepo unlocks powerful workflows, enabling you to make atomic commits to source control with easy access to code."
    }), "\n", _jsx(_components.p, {
      children: "大多数开发任务都是长期运行的任务，会监视代码的更改。Turborepo 通过强大的终端 UI 和其他功能增强了此体验，例如："
    }), "\n", _jsx(_components.p, {
      children: "¥Most development tasks are long-running tasks that watch for changes to your code. Turborepo enhances this experience with a powerful terminal UI and other capabilities like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#configuring-development-tasks",
            children: [_jsx(_components.code, {
              children: "dev"
            }), " 任务配置"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#configuring-development-tasks",
            children: ["Configuration for ", _jsx(_components.code, {
              children: "dev"
            }), " tasks"]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#interacting-with-tasks",
            children: "与任务交互"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#interacting-with-tasks",
            children: "Interacting with tasks"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#watch-mode",
            children: "监视模式"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#watch-mode",
            children: "Watch Mode"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#running-setup-tasks-before-dev",
            children: "正在运行安装脚本"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#running-setup-tasks-before-dev",
            children: "Running setup scripts"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#running-a-specific-application",
            children: "过滤任务以运行包的子集"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#running-a-specific-application",
            children: "Filtering tasks to run a subset of your packages"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "配置开发任务-configuring-development-tasks",
      children: "配置开发任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Configuring development tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中定义开发任务会告知 Turborepo 你将运行一个长期任务。这对于运行开发服务器、运行测试或构建应用等操作非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Defining a development task in ", _jsx(_components.code, {
        children: "turbo.json"
      }), " tells Turborepo that you'll be running a long-lived task. This is useful for things like running a development server, running tests, or building your application."]
    }), "\n", _jsxs(_components.p, {
      children: ["要注册 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务，请将其添加到你的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中，并添加以下两个属性："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To register a ", _jsx(_components.code, {
        children: "dev"
      }), " task, add it to your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " with two properties:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "\"cache\"：false：指示 Turborepo 不要尝试缓存任务的结果。由于这是一项开发任务，你可能会频繁更改代码，因此缓存结果毫无意义。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "\"cache\": false"
          }), ": Tells Turborepo to not attempt to cache the results of the task. Since this is a development task, you're likely to be making frequent changes to your code, so caching the results is not useful."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "\"persistent\"：true:指示 Turborepo 保持任务运行，直到你停止它。此键会向你的终端 UI 触发信号，指示该任务被视为长时间运行且可交互。此外，它还可以防止你意外依赖不会退出的任务。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "\"persistent\": true"
          }), ": Tells Turborepo to keep the task running until you stop it. This key serves as a signal for your terminal UI to treat the task as long-running and interactive. Additionally, it prevents you from accidentally depending on a task that will not exit."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["你现在可以运行 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务来并行启动开发脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can now run your ", _jsx(_components.code, {
        children: "dev"
      }), " task to start your development scripts in parallel:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "在-dev-之前运行设置任务-running-setup-tasks-before-dev",
      children: ["在 ", _jsx(_components.code, {
        children: "dev"
      }), " 之前运行设置任务 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Running setup tasks before ", _jsx(_components.code, {
        children: "dev"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你可能还想运行设置开发环境或预构建包的脚本。你可以使用 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 确保这些任务在 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务之前运行："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You may also want to run scripts that set up your development environment or pre-build packages. You can make sure those tasks run before the ", _jsx(_components.code, {
        children: "dev"
      }), " task with ", _jsx(_components.code, {
        children: "dependsOn"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//#dev:setup\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#dev:setup\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".codegen/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在本例中，我们使用的是 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "根任务"
      }), "，但你可以对 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: "包中的任意任务"
      }), " 使用相同的方法。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In this example, we're using a ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), " but you can use the same idea for ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: "arbitrary tasks in packages"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "运行特定应用-running-a-specific-application",
      children: "运行特定应用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Running a specific application"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--filter"
      }), " 标志允许你选择 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 的子集，以便你可以为特定应用及其依赖运行 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "--filter"
      }), " flag allows you to pick a subset of your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), " so you can run your ", _jsx(_components.code, {
        children: "dev"
      }), " task for a specific application and its dependencies:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "使用终端-ui-using-the-terminal-ui",
      children: "使用终端 UI "
    }), "\n", _jsx(_components.p, {
      children: "¥Using the terminal UI"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 的终端 UI 支持多种功能，可为你的任务创建高度交互的体验。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo's terminal UI enables a number of features that create a highly interactive experience around your tasks."
    }), "\n", _jsx(_components.h3, {
      id: "自定义视图-customizing-your-view",
      children: "自定义视图 "
    }), "\n", _jsx(_components.p, {
      children: "¥Customizing your view"
    }), "\n", _jsx(_components.p, {
      children: "你可以使用快捷键快速调整 UI 以满足你的需求。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can quickly adjust the UI to your needs using keybinds."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "按键绑定"
          }), _jsx(_components.th, {
            children: "操作"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "m"
            })
          }), _jsx(_components.td, {
            children: "切换弹出式按键绑定列表"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "↑"
            }), "/", _jsx(_components.code, {
              children: "↓"
            })]
          }), _jsx(_components.td, {
            children: "在任务列表中选择下一个/上一个任务"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "j"
            }), "/", _jsx(_components.code, {
              children: "k"
            })]
          }), _jsx(_components.td, {
            children: "在任务列表中选择下一个/上一个任务"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "p"
            })
          }), _jsx(_components.td, {
            children: "切换选定任务的固定选择"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "h"
            })
          }), _jsx(_components.td, {
            children: "切换任务列表的可见性"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "c"
            })
          }), _jsx(_components.td, {
            children: "日志高亮显示时，将选定内容复制到系统剪贴板"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "u"
            }), "/", _jsx(_components.code, {
              children: "d"
            })]
          }), _jsxs(_components.td, {
            children: ["滚动日志 ", _jsx(_components.code, {
              children: "u"
            }), "p 和 ", _jsx(_components.code, {
              children: "d"
            }), "own"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "与任务交互-interacting-with-tasks",
      children: "与任务交互 "
    }), "\n", _jsx(_components.p, {
      children: "¥Interacting with tasks"
    }), "\n", _jsx(_components.p, {
      children: "某些工具可能允许你在其中键入输入。例如 Drizzle ORM 的交互式迁移或 Jest 的测试套件过滤和重新运行。"
    }), "\n", _jsx(_components.p, {
      children: "¥Some of your tools may allow you to type input into them. Examples of this include Drizzle ORM's interactive migrations or Jest's filtering and re-running of test suites."
    }), "\n", _jsxs(_components.p, {
      children: ["你可以与 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interactive",
        children: "标记为交互式"
      }), " 任务交互，为其提供输入。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can interact with tasks that are ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interactive",
        children: "marked as interactive"
      }), " to give them input."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "按键绑定"
          }), _jsx(_components.th, {
            children: "操作"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "i"
            })
          }), _jsx(_components.td, {
            children: "开始交互"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "Ctrl+z"
            })
          }), _jsx(_components.td, {
            children: "停止交互"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "监视模式-watch-mode",
      children: "监视模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Watch Mode"
    }), "\n", _jsxs(_components.p, {
      children: ["许多工具都内置了监视器，例如 ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#compiler-options",
        children: _jsx(_components.code, {
          children: "tsc --watch"
        })
      }), "，它可以响应源代码中的更改。但是，有些任务日志不隐藏。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Many tools have a built-in watcher, like ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html#compiler-options",
        children: _jsx(_components.code, {
          children: "tsc --watch"
        })
      }), ",\nthat will respond to changes in your source code. However, some don't."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), " 为任何工具添加了一个依赖感知监视器。源代码的更改将遵循你在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中描述的 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "任务图"
      }), "，就像你的所有其他任务一样。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo watch"
      }), " adds a dependency-aware watcher to any tool. Changes to source code will follow ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "the Task Graph"
      }), " that you've described in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", just like all your other tasks."]
    }), "\n", _jsxs(_components.p, {
      children: ["例如，使用类似 ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), " 的包结构，其中包含以下任务和脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For example, using a package structure like ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), " with the following tasks and scripts:"]
    }), "\n", _jsxs(Tabs, {
      items: ["turbo.json", "packages/ui", "apps/web"],
      children: [_jsx(Tab, {
        value: "turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"persistent\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"cache\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " false"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "packages/ui",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@repo/ui\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ": {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tsc --watch\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "apps/web",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"web\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ": {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"next dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo watch dev lint"
      }), " 时，尽管 ESLint 没有内置的监视程序，但每当你更改源代码时，你都会看到 ", _jsx(_components.code, {
        children: "lint"
      }), " 脚本重新运行。", _jsx(_components.code, {
        children: "turbo watch"
      }), " 还能感知内部依赖，因此 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " 中的代码更改将在 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " 和 ", _jsx(_components.code, {
        children: "web"
      }), " 中重新运行该任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you run ", _jsx(_components.code, {
        children: "turbo watch dev lint"
      }), ", you'll see the ", _jsx(_components.code, {
        children: "lint"
      }), " scripts are re-run whenever you make source code changes, despite ESLint not having a built-in watcher. ", _jsx(_components.code, {
        children: "turbo watch"
      }), " is also aware of internal dependencies, so a code change in ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " will re-run the task in both ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " and ", _jsx(_components.code, {
        children: "web"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "web"
      }), " 中的 Next.js 开发服务器和 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " 中 TypeScript 编译器的内置监视器将继续正常工作，因为它们被标记为 ", _jsx(_components.code, {
        children: "persistent"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The Next.js development server in ", _jsx(_components.code, {
        children: "web"
      }), " and the TypeScript Compiler's built-in watcher in ", _jsx(_components.code, {
        children: "@repo/ui"
      }), " will continue to work as usual, since they are marked with ", _jsx(_components.code, {
        children: "persistent"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["更多信息，请使用 ", _jsxs(_components.a, {
        href: "/docs/reference/watch",
        children: ["访问 ", _jsx(_components.code, {
          children: "turbo watch"
        }), " 参考"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For more information, ", _jsxs(_components.a, {
        href: "/docs/reference/watch",
        children: ["visit the ", _jsx(_components.code, {
          children: "turbo watch"
        }), " reference"]
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "限制-limitations",
      children: "限制 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations"
    }), "\n", _jsx(_components.h3, {
      id: "拆卸任务-teardown-tasks",
      children: "拆卸任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Teardown tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["在某些情况下，你可能希望在 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务停止时运行脚本。Turborepo 在退出时无法运行那些拆卸脚本，因为 ", _jsx(_components.code, {
        children: "turbo"
      }), " 会在你的 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务退出时退出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In some cases, you may want to run a script when the ", _jsx(_components.code, {
        children: "dev"
      }), " task is stopped. Turborepo is unable to run those teardown scripts when exiting because ", _jsx(_components.code, {
        children: "turbo"
      }), " exits when your ", _jsx(_components.code, {
        children: "dev"
      }), " tasks exit."]
    }), "\n", _jsxs(_components.p, {
      children: ["相反，创建一个 ", _jsx(_components.code, {
        children: "turbo dev:teardown"
      }), " 脚本，在退出主要 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " 任务后单独运行该脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Instead, create a ", _jsx(_components.code, {
        children: "turbo dev:teardown"
      }), " script that you run separately after you've exited your primary ", _jsx(_components.code, {
        children: "turbo dev"
      }), " task."]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsx(_components.p, {
      children: "当你有了想要部署的应用版本后，就该学习如何在 Turborepo 中配置环境变量了。"
    }), "\n", _jsx(_components.p, {
      children: "¥Once you have a version of your application that you'd like to deploy, it's time to learn how to configure environment variables in Turborepo."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
